import React from "react";
import styled from "styled-components";

export enum IconId {
  Guitar = "guitar",
  Browse = "browse",
  Dice = "dice",
}

const StyledSVG = styled.svg<{ $rotate; $color; $hoverColor; $size }>`
  ${({ $rotate }) => ($rotate ? `transform: rotate(${$rotate}deg)` : "")};
  ${({ $color, theme }) => {
    return `
				fill: ${$color || theme?.text?.secondary};
				& * {
					fill: ${$color || theme?.text?.secondary}
				}
			`;
  }}
  ${({ $hoverColor, theme }) => {
    if ($hoverColor) {
      return `
				&:hover {
					fill: ${$hoverColor || theme?.text?.secondary};
					& * {
						fill: ${$hoverColor || theme?.text?.secondary}
					}
				}
			`;
    }
  }}
	${({ $size }) => `
		height: ${$size || 16}px;
		width: ${$size || 16}px;
	`}
`;

export const Delete = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 512.001 512.001"
    version="1.1"
    viewBox="0 0 512.001 512.001"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M294.111 256.001L504.109 46.003c10.523-10.524 10.523-27.586 0-38.109-10.524-10.524-27.587-10.524-38.11 0L256 217.892 46.002 7.894C35.478-2.63 18.416-2.63 7.893 7.894s-10.524 27.586 0 38.109l209.998 209.998L7.893 465.999c-10.524 10.524-10.524 27.586 0 38.109 10.524 10.524 27.586 10.523 38.109 0L256 294.11l209.997 209.998c10.524 10.524 27.587 10.523 38.11 0 10.523-10.524 10.523-27.586 0-38.109L294.111 256.001z"></path>
  </StyledSVG>
);

/*export const Up = props => (
	<StyledSVG
		xmlns="http://www.w3.org/2000/svg"
		x="0"
		y="0"
		enableBackground="new 0 0 213.333 213.333"
		version="1.1"
		viewBox="0 0 213.333 213.333"
		xmlSpace="preserve"
		{...props}
	>
		<path d="M106.667 53.333L0 160 213.333 160z"></path>
	</StyledSVG>
);*/

export const Down = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 213.333 213.333"
    version="1.1"
    viewBox="0 0 213.333 213.333"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M0 53.333L106.667 160 213.333 53.333z"></path>
  </StyledSVG>
);

export const Plus = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    width="448pt"
    height="448pt"
    viewBox="0 0 448 448"
    {...props}
  >
    <path d="M408 184H272a8 8 0 01-8-8V40c0-22.09-17.91-40-40-40s-40 17.91-40 40v136a8 8 0 01-8 8H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h136a8 8 0 018 8v136c0 22.09 17.91 40 40 40s40-17.91 40-40V272a8 8 0 018-8h136c22.09 0 40-17.91 40-40s-17.91-40-40-40zm0 0"></path>
  </StyledSVG>
);

export const Minus = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    width="469pt"
    height="469pt"
    viewBox="0 -192 469.333 469"
    {...props}
  >
    <path d="M437.332.168H32c-17.664 0-32 14.336-32 32V53.5c0 17.664 14.336 32 32 32h405.332c17.664 0 32-14.336 32-32V32.168c0-17.664-14.336-32-32-32zm0 0"></path>
  </StyledSVG>
);

export const Edit = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M51.2 353.28L0 512 158.72 460.8z"></path>
    <path
      d="M89.73 169.097H443.007V322.696H89.73z"
      transform="rotate(-45.001 266.366 245.9)"
    ></path>
    <path d="M504.32 79.36L432.64 7.68c-10.24-10.24-25.6-10.24-35.84 0l-23.04 23.04 107.52 107.52 23.04-23.04c10.24-10.24 10.24-25.6 0-35.84z"></path>
  </StyledSVG>
);

export const Confirm = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M504.502 75.496c-9.997-9.998-26.205-9.998-36.204 0L161.594 382.203 43.702 264.311c-9.997-9.998-26.205-9.997-36.204 0-9.998 9.997-9.998 26.205 0 36.203l135.994 135.992c9.994 9.997 26.214 9.99 36.204 0L504.502 111.7c9.998-9.997 9.997-26.206 0-36.204z"></path>
  </StyledSVG>
);

export const Cancel = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 477.867 477.867"
    version="1.1"
    viewBox="0 0 477.867 477.867"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M238.933 0C106.974 0 0 106.974 0 238.933s106.974 238.933 238.933 238.933 238.933-106.974 238.933-238.933C477.726 107.033 370.834.141 238.933 0zM106.224 82.738a204.594 204.594 0 01132.709-48.604 203.84 203.84 0 01132.113 48.555L82.62 371.115C9.505 284.963 20.073 155.853 106.224 82.738zm265.419 312.391a204.594 204.594 0 01-132.709 48.604 203.84 203.84 0 01-132.113-48.555l288.427-288.427c73.114 86.152 62.546 215.263-23.605 288.378z"></path>
  </StyledSVG>
);

export const Menu = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -53 384 384"
    {...props}
  >
    <path d="M368 154.668H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 32H16C7.168 32 0 24.832 0 16S7.168 0 16 0h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M368 277.332H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h352c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0" />
  </StyledSVG>
);

export const GitHub = (props) => (
  <StyledSVG
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 .5C5.37.5 0 5.78 0 12.292c0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56C20.565 21.917 24 17.495 24 12.292 24 5.78 18.627.5 12 .5z" />
  </StyledSVG>
);

export const Maximize = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="512pt"
      height="512pt"
      viewBox="0 0 512 512"
      {...props}
    >
      <path d="M145.969 423.246h-36.707l84.687-84.375-21.172-21.254-84.476 84.164v-36.203h-30v87.668h87.668zm0 0M366.031 423.246v30H453.7v-87.668h-30v36.203l-84.476-84.164-21.172 21.254 84.687 84.375zm0 0M88.3 110.219l84.477 84.164 21.172-21.254-84.687-84.375h36.707v-30H58.3v87.668h30zm0 0M339.223 194.383l84.476-84.164v36.203h30V58.754h-87.668v30h36.707l-84.687 84.375zm0 0"></path>
      <path d="M0 0v512h512V0zm482 482H30V30h452zm0 0"></path>
    </StyledSVG>
  );
};

export const Zoom = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 492.004 492.004"
      version="1.1"
      viewBox="0 0 492.004 492.004"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M484.14 226.886L306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z"></path>
    </StyledSVG>
  );
};

export const Search = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512.005 512.005"
      version="1.1"
      viewBox="0 0 512.005 512.005"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M505.749 475.587l-145.6-145.6c28.203-34.837 45.184-79.104 45.184-127.317C405.333 90.926 314.41.003 202.666.003S0 90.925 0 202.669s90.923 202.667 202.667 202.667c48.213 0 92.48-16.981 127.317-45.184l145.6 145.6c4.16 4.16 9.621 6.251 15.083 6.251s10.923-2.091 15.083-6.251c8.341-8.341 8.341-21.824-.001-30.165zM202.667 362.669c-88.235 0-160-71.765-160-160s71.765-160 160-160 160 71.765 160 160-71.766 160-160 160z"></path>
    </StyledSVG>
  );
};

export const Speaker = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="93.038"
      height="93.038"
      x="0"
      y="0"
      enableBackground="new 0 0 93.038 93.038"
      version="1.1"
      viewBox="0 0 93.038 93.038"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M46.547 75.521a4.221 4.221 0 01-2.429 3.823 4.222 4.222 0 01-4.493-.571l-23.098-19.14H4.225A4.223 4.223 0 010 55.409V38.576a4.226 4.226 0 014.225-4.226h12.303l23.098-19.14a4.215 4.215 0 014.493-.569 4.224 4.224 0 012.429 3.823l-.001 57.057zm16.237-6.602a4.22 4.22 0 01-3.291-1.226l-.565-.567a4.222 4.222 0 01-.408-5.504 24.381 24.381 0 004.834-14.628c0-5.706-1.896-11.058-5.484-15.478a4.222 4.222 0 01.291-5.65l.564-.565c.844-.844 1.975-1.304 3.199-1.231a4.23 4.23 0 013.061 1.545c4.977 6.09 7.606 13.484 7.606 21.38 0 7.354-2.325 14.354-6.725 20.24a4.228 4.228 0 01-3.082 1.684zm17.468 13.057a4.23 4.23 0 01-6.217.262l-.555-.555a4.226 4.226 0 01-.246-5.707 45.101 45.101 0 0010.568-28.982 44.976 44.976 0 00-11.314-29.847 4.226 4.226 0 01.17-5.783l.554-.555a4.113 4.113 0 013.115-1.242 4.225 4.225 0 013.036 1.417 54.173 54.173 0 0113.675 36.01 54.286 54.286 0 01-12.786 34.982z"></path>
    </StyledSVG>
  );
};

export const PlayPause = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="45.974"
      height="45.975"
      x="0"
      y="0"
      enableBackground="new 0 0 45.974 45.975"
      version="1.1"
      viewBox="0 0 45.974 45.975"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M9.629 44.68a4.04 4.04 0 01-6.907-2.85V4.043a4.04 4.04 0 016.907-2.851l17.862 17.951a5.375 5.375 0 010 7.585L9.629 44.68zM38.252 45.975c-2.763 0-5-2.238-5-5V5c0-2.762 2.237-5 5-5a5 5 0 015 5v35.975a5 5 0 01-5 5z"></path>
    </StyledSVG>
  );
};

export const Up = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 240.835 240.835"
      version="1.1"
      viewBox="0 0 240.835 240.835"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M129.007 57.819c-4.68-4.68-12.499-4.68-17.191 0L3.555 165.803c-4.74 4.74-4.74 12.427 0 17.155 4.74 4.74 12.439 4.74 17.179 0l99.683-99.406 99.671 99.418c4.752 4.74 12.439 4.74 17.191 0 4.74-4.74 4.74-12.427 0-17.155L129.007 57.819z"></path>
    </StyledSVG>
  );
};

export const Prev = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 240.823 240.823"
      version="1.1"
      viewBox="0 0 240.823 240.823"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M57.633 129.007L165.93 237.268c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0L57.621 111.816c-4.679 4.691-4.679 12.511.012 17.191z"></path>
    </StyledSVG>
  );
};

export const Next = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 240.823 240.823"
      version="1.1"
      viewBox="0 0 240.823 240.823"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M183.189 111.816L74.892 3.555c-4.752-4.74-12.451-4.74-17.215 0-4.752 4.74-4.752 12.439 0 17.179l99.707 99.671-99.695 99.671c-4.752 4.74-4.752 12.439 0 17.191 4.752 4.74 12.463 4.74 17.215 0l108.297-108.261c4.68-4.691 4.68-12.511-.012-17.19z"></path>
    </StyledSVG>
  );
};

export const More = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="401.991"
      height="401.991"
      x="0"
      y="0"
      enableBackground="new 0 0 401.991 401.991"
      version="1.1"
      viewBox="0 0 401.991 401.991"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M228.406 292.362H173.59c-7.616 0-14.084 2.662-19.414 7.99-5.33 5.329-7.994 11.797-7.994 19.411v54.826c0 7.611 2.664 14.086 7.994 19.41 5.327 5.332 11.798 7.991 19.414 7.991h54.816c7.614 0 14.082-2.663 19.41-7.991s7.994-11.799 7.994-19.41v-54.826c0-7.614-2.666-14.082-7.994-19.411-5.321-5.328-11.796-7.99-19.41-7.99zM228.406 146.181H173.59c-7.616 0-14.084 2.664-19.414 7.994s-7.994 11.798-7.994 19.414v54.819c0 7.618 2.664 14.086 7.994 19.411 5.327 5.332 11.798 7.994 19.414 7.994h54.816c7.614 0 14.082-2.662 19.41-7.994 5.328-5.325 7.994-11.793 7.994-19.411v-54.819c0-7.616-2.666-14.087-7.994-19.414-5.321-5.33-11.796-7.994-19.41-7.994zM247.816 7.993C242.488 2.666 236.02 0 228.406 0H173.59c-7.616 0-14.084 2.663-19.414 7.993-5.33 5.33-7.994 11.803-7.994 19.414v54.821c0 7.616 2.664 14.084 7.994 19.414 5.327 5.327 11.798 7.994 19.414 7.994h54.816c7.614 0 14.082-2.664 19.41-7.994 5.328-5.327 7.994-11.798 7.994-19.414V27.406c.003-7.611-2.659-14.084-7.994-19.413z"></path>
    </StyledSVG>
  );
};

export const Info = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 330 330"
      version="1.1"
      viewBox="0 0 330 330"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M165 .008C74.019.008 0 74.024 0 164.999c0 90.977 74.019 164.992 165 164.992s165-74.015 165-164.992C330 74.024 255.981.008 165 .008zm0 299.984c-74.439 0-135-60.557-135-134.992S90.561 30.008 165 30.008s135 60.557 135 134.991c0 74.437-60.561 134.993-135 134.993z"></path>
      <path d="M165 130.008c-8.284 0-15 6.716-15 15v99.983c0 8.284 6.716 15 15 15s15-6.716 15-15v-99.983c0-8.283-6.716-15-15-15zM165 70.011c-3.95 0-7.811 1.6-10.61 4.39-2.79 2.79-4.39 6.66-4.39 10.61s1.6 7.81 4.39 10.61c2.79 2.79 6.66 4.39 10.61 4.39s7.81-1.6 10.609-4.39c2.79-2.8 4.391-6.66 4.391-10.61s-1.601-7.82-4.391-10.61A15.12 15.12 0 00165 70.011z"></path>
    </StyledSVG>
  );
};

export const Help = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#494c4e"
        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2m0-2C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z"
      ></path>
      <circle cx="12" cy="19" r="1" fill="#494c4e"></circle>
      <path
        fill="#494c4e"
        d="M17 9a5 5 0 01-4 4.9V16c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .55-.45 1-1 1s-1-.45-1-1c0-2.76 2.24-5 5-5s5 2.24 5 5z"
      ></path>
    </StyledSVG>
  );
};

export const Sun = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="96"
      version="1.1"
      viewBox="0 0 96 96"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M81.999 14.117a3.918 3.918 0 010 5.539l-5.772 5.775a3.918 3.918 0 01-5.539 0l-.117-.117a3.919 3.919 0 01-.002-5.54L76.343 14a3.918 3.918 0 015.539 0l.117.117zM48.083 0A3.917 3.917 0 0152 3.917v8.166A3.917 3.917 0 0148.083 16h-.166A3.917 3.917 0 0144 12.083V3.917A3.917 3.917 0 0147.917 0h.166zM25.372 19.716a4 4 0 11-5.656 5.657l-5.656-5.656a4 4 0 115.656-5.657l5.656 5.656zM12 44a4 4 0 010 8H4a4 4 0 010-8h8zM25.432 70.688a3.914 3.914 0 010 5.537L19.655 82a3.915 3.915 0 01-5.537 0l-.119-.118a3.916 3.916 0 010-5.538l5.775-5.775a3.92 3.92 0 015.539 0l.119.119zM48.084 80A3.916 3.916 0 0152 83.916v8.168A3.916 3.916 0 0148.084 96h-.168A3.916 3.916 0 0144 92.084v-8.168A3.916 3.916 0 0147.916 80h.168zM81.999 76.344a3.918 3.918 0 010 5.539l-.117.117a3.918 3.918 0 01-5.539 0l-5.774-5.773a3.92 3.92 0 01.002-5.541l.115-.115a3.92 3.92 0 015.541-.002l5.772 5.775zM92.083 44A3.917 3.917 0 0196 47.917v.165A3.918 3.918 0 0192.083 52h-8.166A3.917 3.917 0 0180 48.083v-.165A3.918 3.918 0 0183.917 44h8.166zM24 48c0 13.255 10.745 24 24 24s24-10.745 24-24-10.745-24-24-24-24 10.745-24 24zm40 0c0 8.836-7.163 16-16 16-8.836 0-16-7.164-16-16 0-8.837 7.164-16 16-16 8.837 0 16 7.163 16 16z"></path>
    </StyledSVG>
  );
};

export const Moon = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="#1D1D1B"
        d="M248.082 263.932c-31.52-31.542-39.979-77.104-26.02-116.542-15.25 5.395-29.668 13.833-41.854 26.02-43.751 43.75-43.751 114.667 0 158.395 43.729 43.73 114.625 43.752 158.374 0 12.229-12.186 20.646-26.604 26.021-41.854-39.415 13.959-84.999 5.5-116.521-26.019z"
      ></path>
    </StyledSVG>
  );
};

export const Browse = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 33.943 33.943"
      version="1.1"
      viewBox="0 0 33.943 33.943"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M5.693 12.626L8.547 12.626 8.547 10.55 25.463 10.55 25.463 23.315 23.627 23.315 23.627 25.47 28.32 25.47 28.32 8.395 5.693 8.395z"></path>
      <path d="M11.312 3.472L11.312 7.702 14.17 7.702 14.17 5.629 31.088 5.629 31.088 18.392 29.252 18.392 29.252 20.547 33.943 20.547 33.943 3.472z"></path>
      <path d="M0 30.471h22.629V13.395H0v17.076zM2.854 15.55h16.918v12.765H2.854V15.55z"></path>
      <path d="M8.695 25.36a1.967 1.967 0 00-1.113-.035c-.883.221-1.463.95-1.291 1.627.096.626 1.021 1.049 1.904.827.777-.191 1.32-.78 1.322-1.38l.023-6.329 4.562-.835v5.088a1.99 1.99 0 00-1.133-.038c-.891.224-1.475.959-1.303 1.644.17.685 1.033 1.059 1.926.837.812-.206 1.332-.764 1.332-1.462v-8.447l-6.23 1.011v7.492h.001z"></path>
    </StyledSVG>
  );
};

export const Guitar = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 313.926 313.926"
      version="1.1"
      viewBox="0 0 313.926 313.926"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M64.647 210.666a7 7 0 00-9.9 9.898l38.282 38.283a6.978 6.978 0 004.95 2.051 7 7 0 004.95-11.949l-38.282-38.283zM103.849 191.187a7 7 0 00-9.9 9.898l18.561 18.562a6.978 6.978 0 004.95 2.051 7 7 0 004.95-11.949l-18.561-18.562z"></path>
      <path d="M312.64 22.521c-1.567-6.819-3.348-11.263-5.288-13.201-2.568-2.569-5.753-3.984-8.967-3.984-1.64 0-3.231.357-4.729 1.06a222.268 222.268 0 00-5.027 2.442l-6.547-6.548a7 7 0 00-9.9 9.898l3.441 3.441a876.83 876.83 0 00-9.121 4.987l-3.877-3.878a7.002 7.002 0 00-9.9 0 7.002 7.002 0 000 9.9l1.101 1.101a1172.378 1172.378 0 00-10.656 6.13 7.02 7.02 0 00-1.423 1.098c-3.324 3.326-4.343 8.109-3.093 12.412l-85.52 85.52c-.584-.281-1.162-.556-1.728-.822-3.704-1.747-6.903-3.256-9.918-6.271-2.689-2.689 4.236-13.904 7.957-19.93 6.492-10.513 13.205-21.384 5.478-29.111-1.462-1.462-4.078-3.205-8.237-3.205-10.996 0-26.237 12.858-29.421 16.042-12.234 12.234-17.166 21.781-21.937 31.014-4.199 8.128-8.166 15.806-17.563 25.203-7.012 7.012-16.218 10.502-25.965 14.198-11.222 4.255-22.825 8.654-32.828 18.656-43.276 43.277-1.157 85.398 14.698 101.255 15.718 15.717 36.824 33.759 60.724 33.758 14.246-.001 27.883-6.414 40.531-19.063 10.001-10.002 14.401-21.605 18.656-32.827 3.695-9.747 7.186-18.953 14.197-25.964 6.785-6.786 12.096-9.278 18.244-12.164 6.388-2.998 13.628-6.396 22.087-14.854 20.867-20.868 19.424-31.071 14.538-35.957-2.621-2.621-6.113-3.949-10.379-3.949-4.824 0-10.106 1.698-15.7 3.497-5.554 1.785-11.298 3.633-16.074 3.633-3.153-.001-5.349-.789-7.115-2.557-1.195-1.195-2.021-2.198-2.581-3.119l95.411-95.411a12.89 12.89 0 003.614.521c3.342 0 6.47-1.286 8.809-3.623l32.636-32.637c3.046-3.049 3.432-7.729 1.372-16.691zm-65.233 35.904l7.763 7.764-84.21 84.21c-.879-2.973-2.678-6.174-6.015-9.51l-.001-.001 82.463-82.463zm-66.914 131.614c.001 0 0 0 0 0 6.972 0 14.085-2.287 20.36-4.306 3.612-1.161 7.328-2.356 9.985-2.716-1.885 3.648-6.551 9.818-12.63 15.897-6.726 6.726-12.014 9.207-18.136 12.08-6.411 3.01-13.678 6.42-22.196 14.938-9.137 9.138-13.331 20.201-17.388 30.9-3.903 10.293-7.589 20.016-15.466 27.892-10.066 10.067-20.086 14.961-30.632 14.962-18.759 0-37.015-15.85-50.822-29.657-10.553-10.553-23.257-24.585-27.872-39.549-4.558-14.777-.249-28.485 13.173-41.907 7.877-7.877 17.6-11.563 27.892-15.466 10.699-4.057 21.764-8.252 30.901-17.389 10.936-10.937 15.595-19.955 20.102-28.677 4.476-8.662 8.703-16.845 19.397-27.54 4.192-4.192 11.39-8.974 16.093-10.978-1.427 3.039-3.978 7.17-5.724 9.997-6.948 11.252-16.466 26.663-5.944 37.185 4.738 4.737 9.576 7.02 13.845 9.033 3.62 1.708 6.747 3.183 9.613 6.05 3.256 3.256 2.944 4.518 1.912 8.699-1.37 5.549-3.44 13.934 6.52 23.895 4.419 4.416 10.143 6.656 17.017 6.657zM269.73 60.95l-16.645-16.646c7.912-4.567 30.409-17.434 44.362-24.205 1.018 2.968 2.224 8.05 2.44 10.694L269.73 60.95z"></path>
    </StyledSVG>
  );
};

export const Dice = (props) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="640"
      height="640"
      viewBox="0 -64 640 640"
      {...props}
    >
      <path d="M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"></path>
    </StyledSVG>
  );
};

const ICON = {
  // Directions
  up: Up,
  down: Down,
  prev: Prev,
  next: Next,
  // Actions
  close: Delete,
  delete: Delete,
  edit: Edit,
  confirm: Confirm,
  cancel: Cancel,
  zoom: Zoom,
  search: Search,
  speaker: Speaker,
  playPause: PlayPause,
  // Utility
  plus: Plus,
  minus: Minus,
  menu: Menu,
  more: More,
  maximize: Maximize,
  help: Help,
  info: Info,
  // Social
  github: GitHub,
  // Night mode
  sun: Sun,
  moon: Moon,
  ///
  browse: Browse,
  guitar: Guitar,
  dice: Dice,
};

interface IIconProps {
  iconId: string | IconId;
  color?: string;
  hoverColor?: string;
  size?: number;
  rotate?: number;
  className?: string;
}

const Icon: React.FC<IIconProps> = ({
  iconId,
  color,
  hoverColor,
  size = 16,
  rotate,
  ...props
}) => {
  const IconComponent = ICON[iconId];
  return (
    <IconComponent
      $color={color}
      $hoverColor={hoverColor}
      $size={size}
      $rotate={rotate}
      {...props}
    />
  );
};

export default Icon;
